<div class="dr-page">

  <!-- ============================================================
       PAGE HEADER
       ============================================================ -->
  <section class="dr-header">
    <div class="dr-header-blob dr-header-blob--1"></div>
    <div class="dr-header-blob dr-header-blob--2"></div>
    <div class="dr-container">
      <div class="dr-header-inner">
        <div class="dr-header-eyebrow">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
          Free Resources
        </div>
        <h1 class="dr-header-title">Download Free <span>11+ Resources</span></h1>
        <p class="dr-header-sub">Expert-prepared practice papers, revision guides and study materials — completely free for every student</p>

        <!-- Search + filter row -->
        <div class="dr-search-row">
          <div class="dr-search-wrap">
            <svg class="dr-search-ico" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4-4"/></svg>
            <input type="text" class="dr-search-input" placeholder="Search resources..."
                   [(ngModel)]="searchQuery" (input)="filterResources()" />
          </div>
          <div class="dr-filter-pills">
            <button class="dr-filter-pill"
                    *ngFor="let cat of categories"
                    [class.dr-filter-pill--on]="activeCategory === cat"
                    (click)="setCategory(cat)">
              {{ cat }}
            </button>
          </div>
        </div>

      </div>
    </div>
  </section>

  <!-- ============================================================
       STATS STRIP
       ============================================================ -->
  <div class="dr-strip">
    <div class="dr-container">
      <div class="dr-strip-inner">
        <div class="dr-strip-item">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
          <span><strong>{{ resources.length }}+</strong> Free Resources</span>
        </div>
        <div class="dr-strip-item">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/></svg>
          <span><strong>10,000+</strong> Downloads</span>
        </div>
        <div class="dr-strip-item">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
          <span><strong>100%</strong> Free &amp; Verified</span>
        </div>
        <div class="dr-strip-item">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
          <span>Updated <strong>Regularly</strong></span>
        </div>
      </div>
    </div>
  </div>

  <!-- ============================================================
       RESOURCE GRID
       ============================================================ -->
  <section class="dr-grid-section">
    <div class="dr-container">

      <!-- Results count -->
      <div class="dr-results-bar">
        <span class="dr-results-count">
          Showing <strong>{{ filteredResources.length }}</strong> resource{{ filteredResources.length !== 1 ? 's' : '' }}
          <span *ngIf="activeCategory !== 'All'"> in <em>{{ activeCategory }}</em></span>
        </span>
      </div>

      <!-- Empty state -->
      <div class="dr-empty" *ngIf="filteredResources.length === 0">
        <div class="dr-empty-icon">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4-4"/></svg>
        </div>
        <h3 class="dr-empty-title">No resources found</h3>
        <p class="dr-empty-sub">Try a different search term or category</p>
        <button class="dr-empty-reset" (click)="resetFilters()">Clear filters</button>
      </div>

      <!-- Cards grid -->
      <div class="dr-grid" *ngIf="filteredResources.length > 0">
        <div class="dr-card" *ngFor="let res of filteredResources">

          <!-- Top accent strip by type -->
          <div class="dr-card-accent" [ngClass]="'dr-card-accent--' + res.colorKey"></div>

          <!-- Card header -->
          <div class="dr-card-header">
            <div class="dr-card-icon" [ngClass]="'dr-card-icon--' + res.colorKey">
              <!-- Maths icon -->
              <svg *ngIf="res.icon === 'maths'" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>
              <!-- English icon -->
              <svg *ngIf="res.icon === 'english'" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/></svg>
              <!-- VR icon -->
              <svg *ngIf="res.icon === 'vr'" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
              <!-- NVR icon -->
              <svg *ngIf="res.icon === 'nvr'" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>
              <!-- Guide icon -->
              <svg *ngIf="res.icon === 'guide'" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/></svg>
              <!-- Paper icon -->
              <svg *ngIf="res.icon === 'paper'" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>
            </div>
            <div class="dr-card-tags">
              <span class="dr-tag" [ngClass]="'dr-tag--' + res.colorKey">{{ res.category }}</span>
              <span class="dr-tag dr-tag--outline" *ngIf="res.level">{{ res.level }}</span>
            </div>
          </div>

          <!-- Card body -->
          <div class="dr-card-body">
            <h3 class="dr-card-title">{{ res.title }}</h3>
            <p class="dr-card-desc">{{ res.description }}</p>

            <div class="dr-card-meta">
              <span class="dr-meta-item">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
                {{ res.fileType }} · {{ res.fileSize }}
              </span>
              <span class="dr-meta-item">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/></svg>
                {{ res.downloads }} downloads
              </span>
            </div>
          </div>

          <!-- Card footer -->
          <div class="dr-card-footer">
            <button class="dr-download-btn" (click)="openModal(res)">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
              Free Download
            </button>
          </div>

        </div>
      </div>

    </div>
  </section>

  <!-- ============================================================
       DOWNLOAD MODAL — Form → Download button
       ============================================================ -->
  <div class="dr-modal-ov" *ngIf="showModal" (click)="closeModal()">
    <div class="dr-modal" (click)="$event.stopPropagation()">

      <!-- Close -->
      <button class="dr-modal-close" (click)="closeModal()" aria-label="Close">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
      </button>

      <!-- === STEP 1: FORM === -->
      <div class="dr-modal-step" *ngIf="!formSubmitted">

        <!-- Resource preview -->
        <div class="dr-modal-resource">
          <div class="dr-modal-res-icon" [ngClass]="'dr-card-icon--' + selectedResource?.colorKey">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>
          </div>
          <div class="dr-modal-res-info">
            <span class="dr-modal-res-tag" [ngClass]="'dr-tag--' + (selectedResource?.colorKey || 'navy')">{{ selectedResource?.category }}</span>
            <h3 class="dr-modal-res-title">{{ selectedResource?.title }}</h3>
            <p class="dr-modal-res-meta">{{ selectedResource?.fileType }} · {{ selectedResource?.fileSize }}</p>
          </div>
        </div>

        <!-- Form header -->
        <div class="dr-modal-form-header">
          <h2 class="dr-modal-title">Almost There!</h2>
          <p class="dr-modal-sub">Enter your details to get instant free access. No spam — ever.</p>
        </div>

        <!-- Form -->
        <form class="dr-form" (ngSubmit)="submitForm()" novalidate>

          <div class="dr-form-row">
            <div class="dr-form-group" [class.dr-form-group--error]="formErrors.firstName">
              <label class="dr-label" for="dr-fname">
                First Name <span class="dr-required">*</span>
              </label>
              <input
                type="text"
                id="dr-fname"
                class="dr-input"
                placeholder="e.g. Priya"
                [(ngModel)]="formData.firstName"
                name="firstName"
                (input)="clearError('firstName')" />
              <span class="dr-error-msg" *ngIf="formErrors.firstName">{{ formErrors.firstName }}</span>
            </div>

            <div class="dr-form-group" [class.dr-form-group--error]="formErrors.lastName">
              <label class="dr-label" for="dr-lname">
                Last Name <span class="dr-required">*</span>
              </label>
              <input
                type="text"
                id="dr-lname"
                class="dr-input"
                placeholder="e.g. Sharma"
                [(ngModel)]="formData.lastName"
                name="lastName"
                (input)="clearError('lastName')" />
              <span class="dr-error-msg" *ngIf="formErrors.lastName">{{ formErrors.lastName }}</span>
            </div>
          </div>

          <div class="dr-form-group" [class.dr-form-group--error]="formErrors.email">
            <label class="dr-label" for="dr-email">
              Email Address <span class="dr-required">*</span>
            </label>
            <div class="dr-input-wrap">
              <svg class="dr-input-ico" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
              <input
                type="email"
                id="dr-email"
                class="dr-input dr-input--ico"
                placeholder="e.g. priya@email.com"
                [(ngModel)]="formData.email"
                name="email"
                (input)="clearError('email')" />
            </div>
            <span class="dr-error-msg" *ngIf="formErrors.email">{{ formErrors.email }}</span>
          </div>

          <div class="dr-form-group">
            <label class="dr-label" for="dr-phone">
              Phone Number <span class="dr-required">*</span>
            </label>
            <div class="dr-input-wrap">
              <svg class="dr-input-ico" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.36 2 2 0 0 1 3.6 1.18h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.84a16 16 0 0 0 6 6l.91-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7a2 2 0 0 1 1.72 2.03z"/></svg>
              <input
                type="tel"
                id="dr-phone"
                class="dr-input dr-input--ico"
                placeholder="e.g. +44 7700 900000"
                [(ngModel)]="formData.phone"
                name="phone" 
                (input)="clearError('phone')"/>
            </div>
             <span class="dr-error-msg" *ngIf="formErrors.phone">{{ formErrors.phone }}</span>
            <span class="dr-field-hint">We'll only use this to send you relevant updates if you opt in</span>
          </div>

          <!-- Consent checkbox -->
          <div class="dr-consent">
            <label class="dr-checkbox-label">
              <input type="checkbox"
                     class="dr-checkbox"
                     [(ngModel)]="formData.consent"
                     name="consent" />
              <span class="dr-checkbox-custom"></span>
              <span class="dr-consent-text">
                I agree to receive helpful 11+ preparation tips and resources from Sehyog Academy.
                You can unsubscribe anytime.
              </span>
            </label>
          </div>

          <button type="submit" class="dr-submit-btn" [disabled]="isSubmitting">
            <span *ngIf="!isSubmitting">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
              Get Free Download
            </span>
            <span *ngIf="isSubmitting" class="dr-spinner-wrap">
              <svg class="dr-spinner" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12a9 9 0 1 1-6.219-8.56"/></svg>
              Preparing your download...
            </span>
          </button>

          <p class="dr-privacy-note">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
            Your information is safe and will never be shared with third parties.
          </p>

        </form>
      </div>

      <!-- === STEP 2: SUCCESS + DOWNLOAD === -->
      <div class="dr-modal-step dr-modal-success" *ngIf="formSubmitted">

        <div class="dr-success-icon">
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
        </div>

        <h2 class="dr-success-title">You're all set, {{ formData.firstName }}!</h2>
        <p class="dr-success-sub">Your free resource is ready. Click the button below to start your download.</p>

        <!-- Resource card recap -->
        <div class="dr-success-resource">
          <div class="dr-success-res-icon" [ngClass]="'dr-card-icon--' + (selectedResource?.colorKey || 'navy')">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
          </div>
          <div>
            <div class="dr-success-res-name">{{ selectedResource?.title }}</div>
            <div class="dr-success-res-meta">{{ selectedResource?.fileType }} · {{ selectedResource?.fileSize }}</div>
          </div>
        </div>

        <!-- THE DOWNLOAD BUTTON — only shows after form is complete -->
        <a [href]="selectedResource?.fileUrl"
           [download]="selectedResource?.fileName"
           class="dr-final-download-btn"
           (click)="onDownloadClick()">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
          Download Now
        </a>

        <p class="dr-success-hint">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
          A copy has also been sent to <strong>{{ formData.email }}</strong>
        </p>

        <div class="dr-success-more">
          <p>Looking for more resources?</p>
          <button class="dr-more-btn" (click)="closeAndBrowse()">Browse More Downloads</button>
        </div>

      </div>

    </div>
  </div>

  <!-- ============================================================
       BOTTOM CTA STRIP
       ============================================================ -->
  <div class="dr-cta-strip">
    <div class="dr-container">
      <div class="dr-cta-inner">
        <div>
          <h3 class="dr-cta-title">Need More than Resources?</h3>
          <p class="dr-cta-sub">Join 10,000+ students with expert tuition, mock exams and personalised feedback.</p>
        </div>
        <a routerLink="/freedemo" class="dr-cta-btn">
          Book a Free Demo
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
        </a>
      </div>
    </div>
  </div>

</div>